import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Flower2, Sparkles } from "lucide-react";

const Hero = () => (
  <section
    id="inicio"
    className="relative overflow-hidden border-b border-slate-100"
  >
    {/* Fondo primaveral con gradient soft */}
    <div className="pointer-events-none absolute inset-0">
      <div className="absolute inset-0 bg-gradient-to-br from-pink-50 via-white to-sky-50" />
      <div className="absolute -left-40 top-0 h-[32rem] w-[32rem] rounded-full bg-pink-200/40 blur-3xl" />
      <div className="absolute right-0 top-40 h-[28rem] w-[28rem] rounded-full bg-sky-200/50 blur-3xl" />
    </div>

    <div className="relative mx-auto grid max-w-7xl gap-8 px-6 py-12 md:py-16 lg:grid-cols-2 lg:items-center">
      <div>
        <Badge className="rounded-full border border-pink-200 bg-pink-100 px-4 py-1 font-bold text-pink-700 hover:bg-pink-100">
          <Flower2 className="mr-1.5 h-3.5 w-3.5" /> Primavera 2026 · Nueva imagen
        </Badge>
        <h1 className="mt-4 text-4xl font-black leading-[1.05] tracking-tight text-slate-900 md:text-6xl">
          Fibra óptica{" "}
          <span className="bg-gradient-to-r from-pink-500 via-rose-500 to-sky-500 bg-clip-text text-transparent">
            fresca y estable
          </span>{" "}
          para tu casa
        </h1>
        <p className="mt-4 max-w-xl text-lg text-slate-600">
          Internet 100% fibra en Zona Oeste y Baradero. Sin límite de datos,
          soporte local de verdad y atención humana. Una empresa que responde.
        </p>

        <div className="mt-6 flex flex-wrap gap-3">
          <Button
            data-testid="hero-ver-planes"
            asChild
            className="rounded-full bg-gradient-to-r from-pink-500 to-rose-500 px-6 py-6 text-base font-bold text-white shadow-lg shadow-pink-200 hover:from-pink-600 hover:to-rose-600"
          >
            <a href="#planes">
              Ver Planes <ArrowRight className="ml-1 h-4 w-4" />
            </a>
          </Button>
          <Button
            data-testid="hero-solicitar"
            asChild
            variant="outline"
            className="rounded-full border-slate-300 bg-white px-6 py-6 text-base font-bold text-slate-800 hover:bg-slate-50 hover:text-slate-900"
          >
            <a href="#contacto">
              <Sparkles className="mr-2 h-4 w-4 text-sky-500" /> Solicitar Servicio
            </a>
          </Button>
        </div>

        <div className="mt-8 grid max-w-md grid-cols-3 gap-6">
          {[
            { v: "1 Gbps", l: "Velocidad máxima" },
            { v: "99.9%", l: "Disponibilidad" },
            { v: "24/7", l: "Soporte local" },
          ].map((s) => (
            <div key={s.l}>
              <p className="text-2xl font-black text-slate-900 md:text-3xl">
                {s.v}
              </p>
              <p className="mt-1 text-[11px] uppercase tracking-widest text-slate-500">
                {s.l}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="relative">
        <div className="absolute -inset-6 rounded-[2.5rem] bg-gradient-to-br from-pink-300/60 via-fuchsia-200/40 to-sky-300/60 blur-3xl" />
        <div className="relative overflow-hidden rounded-[2.5rem] border-4 border-white shadow-[0_25px_80px_-15px_rgba(236,72,153,0.35)]">
          <img
            src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1400&q=80"
            alt="Amigos disfrutando internet, redes sociales y entretenimiento"
            className="aspect-[4/5] w-full object-cover md:aspect-[4/4]"
          />
          {/* Overlay gradient sutil */}
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-pink-500/25 via-transparent to-sky-400/15" />

          {/* Badge fibra */}
          <div className="absolute bottom-5 left-5 flex items-center gap-2 rounded-full bg-white/95 px-4 py-2 shadow-lg backdrop-blur">
            <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-500" />
            <span className="text-xs font-bold text-slate-800">
              Fibra óptica FTTH activa
            </span>
          </div>

          {/* Badge velocidad flotante */}
          <div className="absolute right-5 top-5 rounded-2xl border-2 border-white bg-gradient-to-br from-pink-500 to-rose-500 px-4 py-3 text-white shadow-xl">
            <p className="text-[10px] font-bold uppercase tracking-widest">
              Hasta
            </p>
            <p className="text-2xl font-black leading-none">1 Gbps</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
